import { clsx } from 'clsx'

import { Empty } from '../Common/Empty'
import type { PostType, ProfilePreview, YoutubeDraft } from '../types'
import { YoutubePost } from './components/Post'
import commonStyles from '../Common/Common.module.css'
import { PostPreviewCard } from '../Common/styles'

import styles from './YoutubePreview.module.css'

import type { JSX } from 'react'

export const YoutubePreview = ({
  draft,
  profile,
}: {
  draft: YoutubeDraft
  profile: ProfilePreview
}): JSX.Element => {
  const draftYoutube: PostType = {
    content: {
      ...draft,
      text: draft.text,
    },
  }

  if (draft.isEmpty) return <Empty />

  return (
    <PostPreviewCard
      className={clsx(commonStyles.videoPreview, styles.youtubePreview)}
      data-testid="youtube-preview"
    >
      <YoutubePost content={draftYoutube.content} profile={profile} />
    </PostPreviewCard>
  )
}
